import { render, staticRenderFns } from "./GatewayTable.global.vue?vue&type=template&id=971ae842&lang=pug&"
import script from "./GatewayTable.global.vue?vue&type=script&lang=ts&"
export * from "./GatewayTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports